// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"067b50f2","453":"7d575a43","806":"ddcbcd52"}[chunkId] + ".chunk.js";
};